import * as React from 'react';
import { Breadcrumbs } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { LocaleUtils, StringUtils } from '@grandvisionhq/utils';
import '@swc/helpers';
import { useBrPageContext } from '../../../context/context.js';
import '@bloomreach/react-sdk';
import '../../../context/configuration.js';
import '@bloomreach/spa-sdk';
import { getUrl } from '../../../utils/get-url.js';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../../operations/mutations/signup-promotion.js';
import '../../../operations/mutations/subscribe-newsletter.js';
import '../../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageRoutes } from '../../../hooks/use-bloomreach-page-routes.js';
import '../../../hooks/use-breakpoint-visibility.js';

const CmsContentBreadcrumbs = ({ url  })=>{
    const breadcrumbs = useBreadcrumbs(url);
    // Don't render if we have less than 2 breadcrumb items
    if (!breadcrumbs || breadcrumbs.length < 2) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Breadcrumbs, {
        pages: breadcrumbs
    }));
};
function useBreadcrumbs(url = '') {
    const { getLabel , hasLabel , locale: defaultLocale  } = useIntl();
    const { routes  } = useBloomreachPageRoutes();
    const { isMultilingualEnabled  } = useFeatureToggles();
    const page = useBrPageContext();
    // Get locale from url because locale from cookies(intl) is not always up to date in preview mode
    const locale = LocaleUtils.getLocaleFromUrl(url) || defaultLocale;
    const localeStr = locale.replace('-', '_');
    const [path = '', queryString = ''] = url === null || url === void 0 ? void 0 : url.split('?');
    let segments = path.split('/');
    // If we get an "internal" bloomreach url, we need to slice of the first three items (/site/_cmsinternal/[channel])
    // so they won't show up in the visual breadcrumbs
    if ((page === null || page === void 0 ? void 0 : page.isPreview()) && path.startsWith('/site/_cmsinternal')) {
        segments = [
            ...segments
        ].filter((s)=>s !== '' && s !== localeStr
        ).slice(3, segments.length - 1);
    } else {
        segments = segments.filter((s)=>s !== '' && s !== localeStr
        );
    }
    return [
        {
            name: getLabel(`breadcrumb.breadcrumb.home`),
            url: (page === null || page === void 0 ? void 0 : page.isPreview()) ? page === null || page === void 0 ? void 0 : page.getUrl(routes.root) : routes.root
        },
        ...segments.map((currentSegment, index)=>createUrlBreadcrumb({
                currentSegment,
                segments,
                queryString,
                index,
                getLabel,
                hasLabel,
                page,
                locale: isMultilingualEnabled ? localeStr : undefined
            })
        ), 
    ];
}
function createUrlBreadcrumb({ segments , currentSegment , queryString , index , getLabel , hasLabel , page , locale  }) {
    const previous = segments.slice(0, index).join('/');
    const labelKey = `breadcrumb.breadcrumb.${currentSegment}`;
    const name = hasLabel(labelKey) ? getLabel(labelKey) : StringUtils.upFirst(currentSegment.replace(/-/g, ' '));
    let url = previous ? `/${previous}/${currentSegment}` : `/${currentSegment}`;
    if (queryString) url += `?${queryString}`;
    if (locale) {
        url = `/${locale}${url}`;
    }
    return {
        url: getUrl(url, page),
        name
    };
}

export { CmsContentBreadcrumbs, CmsContentBreadcrumbs as default };
//# sourceMappingURL=ContentBreadcrumbs.js.map
